import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { RotateLoader } from "react-spinners";

import { FaSyncAlt, FaTimes } from "react-icons/fa";
import { GoSearch } from "react-icons/go";
import { BsShopWindow } from "react-icons/bs";
import { AiOutlineSortAscending } from "react-icons/ai";
import { AuthContext } from "../../context/main/auth-context";
import "../../css/orders/orders.css";

import flagNetherlands from "../../images/main/flag-netherlands.svg";
import flagBelgium from "../../images/main/flag-belgium.svg";
import worldGlobe from "../../images/main/world-globe.svg";

import getAllOpenOrdersFbrDbr from "../../components/bol/get-all-open-orders-fbr-dbr";
import OrdersHeader from "../../components/orders/orders-header";
import refetchOpenOrders from "../../components/orders/refetch-all-open-orders";
import OrderListItemOpen from "../../components/orders/order-list-item-open";
import AssistantToggleButton from "../../components/main/assistant-toggle-button";
import CancelOrderItemModal from "../../components/bol/cancel-order-item-modal";

import getProductBySku from "../../api/mongodb/get-product-by-sku";
import getProductsBySkus from "../../api/mongodb/get-products-by-skus";

const OrdersFbrDbr = (props) => {
	const { accountSaleNumber } = useParams();
	const auth = useContext(AuthContext);
	const navigate = useNavigate();

	const sortingNameHandler = (input) => {
		if (input === `{"orderItems.offer.reference":1}`) {
			return "Productgroep (SKU)";
		} else if (input === `{"orderPlacedDateTime":1}`) {
			return "Besteldatum (Oud - Nieuw)";
		} else {
			return "Besteldatum (Nieuw - Oud)";
		}
	};
	const sortingHandler = () => {
		let sortingOrders = JSON.parse(sessionStorage.getItem("openOrdersSorting"));
		if (sortingOrders) {
			return sortingOrders;
		} else {
			return `{"orderPlacedDateTime":-1}`;
		}
	};

	const accountFilterHandler = () => {
		let accountFilter = JSON.parse(
			sessionStorage.getItem("openOrdersFilterByAccount")
		);
		if (accountFilter) {
			return accountFilter;
		} else {
			return `{"$exists":true}`;
		}
	};

	const sortOrders = (sorting) => {
		if (sorting) {
			sessionStorage.setItem("openOrdersSorting", JSON.stringify(sorting));
		}
		setSortOrdersFilter(sorting);
	};

	const filterOrdersByAccount = (accountSaleNumber) => {
		if (accountSaleNumber) {
			sessionStorage.setItem(
				"openOrdersFilterByAccount",
				JSON.stringify(accountSaleNumber)
			);
		}
		setAccountFilter(accountSaleNumber);
	};

	const [errorMessage, setErrorMessage] = useState(false);
	const [openOrders, setOpenOrders] = useState([]);
	const [loadingState, setLoadingState] = useState(false);
	const [refetchRemainingTime, setRefetchRemainingTime] = useState(false);
	const [pageCount, setPageCount] = useState();
	const [currentPage, setCurrentPage] = useState(0);
	const [offset, setOffset] = useState(0);
	const [perPage, setPerPage] = useState(25);
	const [ordersToShow, setOrdersToShow] = useState(false);
	const [checkedOrders, setCheckedOrders] = useState([]);
	const [recountOrders, setRecountOrders] = useState(false);
	const [cancelOrderItemModal, setCancelOrderItemModal] = useState(false);
	const [cancelResponse, setCancelResponse] = useState();
	const [loadingPage, setLoadingPage] = useState(false);
	const [showAlertText, setShowAlertText] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");
	const [sortOrdersFilter, setSortOrdersFilter] = useState(sortingHandler);
	const [accountFilter, setAccountFilter] = useState(accountFilterHandler);
	const [filterCountry, setFilterCountry] = useState("ALL");
	const [filterCountryImg, setFilterCountryImg] = useState(worldGlobe);
	// ⬇️ NIEUW
const [filteredOrders, setFilteredOrders] = useState([]);

const showPage = (list, pageIndex = 0) => {
  const start = pageIndex * perPage;
  const end = start + perPage;
  setOrdersToShow(list.slice(start, end));
  setPageCount(Math.ceil(list.length / perPage));
  setCurrentPage(pageIndex);
  setOffset(start);
};

useEffect(() => {
  (async () => {
    setLoadingState("Bestellingen worden geladen");

    const openOrders = await getAllOpenOrdersFbrDbr(auth.token, sortOrdersFilter, accountFilter);

    if (!openOrders || !openOrders.orders || openOrders.orders.length === 0) {
      setOpenOrders(0);
      setErrorMessage("Geen openstaande orders gevonden");
      setOrdersToShow(false);
      setLoadingState(false);
      return;
    }

    // 1) Unieke SKUs pakken uit ALLE orderItems
    const skus = [
      ...new Set(
        openOrders.orders.flatMap((o) =>
          (o.orderItems || [])
            .map((it) => it?.offer?.reference)
            .filter(Boolean)
            .map(String) // normaliseer type (leading zeros blijven behouden)
        )
      ),
    ];

    // 2) Batch producten ophalen
    let bySku = {};
if (skus.length) {
  try {
    const resp = await getProductsBySkus(skus, auth.token); // { products: [...] }
    const products = (resp && resp.products) || [];
    bySku = Object.fromEntries(products.map((p) => [String(p.sku), p]));
  } catch (e) {
    console.warn("SKU enrichment skipped:", e);
  }
}

// 3) Orders verrijken met productdata → title, ean, image, etc.
const enrichedOrders = openOrders.orders.map((o) => ({
  ...o,
  orderItems: (o.orderItems || []).map((it) => {
    const sku = String(it?.offer?.reference || "");
    const p = bySku[sku];
    if (!p) return it;

    // pad normaliseren voor je /s3/ route
    const imageKey = (p.image || "")
      .replace(/^\/?s3\//, "")
      .replace(/\s+\/+/g, "/")  // "folder ␠ /file" -> "folder/file"
      .trim();

    return {
      ...it,

      // legacy / back-compat: sommige components lezen top-level productData.*
      productData: {
        ...(it.productData || {}),
        _id: p._id,
        title: p.title,
        sku: p.sku,
        ean: p.ean,
        image: imageKey,              // ✅ nu aanwezig
      },

      // voorkeursstructuur
      product: {
        ...(it.product || {}),
        title: p.title ?? it.product?.title,
        ean: p.ean ?? it.product?.ean,
        productData: {
          ...(it.product?.productData || {}),
          _id: p._id,
          title: p.title,
          sku: p.sku,
          ean: p.ean,
          image: imageKey,            // ✅ nu aanwezig
        },
      },
    };
  }),
}));

    // 4) Pagineren + state
setOpenOrders(enrichedOrders);
setFilteredOrders(enrichedOrders);
showPage(enrichedOrders, 0);
setLoadingState(false);
setErrorMessage(false);
  })();
}, [auth.token, sortOrdersFilter, accountFilter]);

const handlePageClick = (e) => {
  // bestaande checkbox-reset mag blijven
  const allCheckboxes = Array.from(
    document.querySelectorAll(".o-li-item input, .checkbox-all-orders  input")
  );
  allCheckboxes.forEach((checkbox) => {
    if (checkbox.checked === true) checkbox.click();
  });

  setCheckedOrders([]);
  setLoadingState("Bestellingen worden geladen");

  const selectedPage = e.selected;
  showPage(filteredOrders, selectedPage);

  setLoadingState(false);
  setSearchQuery("");
};

const filterOrdersByCountry = async (e) => {
  setFilterCountry(e);
  if (e === "NL") {
    setFilterCountryImg(flagNetherlands);
  } else if (e === "BE") {
    setFilterCountryImg(flagBelgium);
  } else {
    setFilterCountryImg(worldGlobe);
  }

  const list =
    e === "ALL"
      ? (openOrders || [])
      : (openOrders || []).filter(
          (order) => order?.shipmentDetails?.countryCode === e
        );

  setFilteredOrders(list);
  showPage(list, 0);
};

	const refetchOpenOrdersHandler = async () => {
		setLoadingState([
			"Nieuwe Bestellingen ophalen",
			<br />,
			<br />,
			"Dit kan enkele minuten duren",
		]);

		let fetchedTime = Number(sessionStorage.getItem("refetchAllOpenOrdersTime"));
		if (fetchedTime && fetchedTime !== null) {
			if (Date.now() - fetchedTime > 60000) {
				setRefetchRemainingTime(false);
				sessionStorage.setItem("refetchAllOpenOrdersTime", Date.now());
				const refetch = await refetchOpenOrders(auth.token);
				if (refetch && refetch.status === 200) {
					window.location.reload(true);
				}
			} else {
				const remainingTime = 60 - (Date.now() - fetchedTime) / 1000;
				setRefetchRemainingTime(remainingTime.toFixed(0));
			}
			setLoadingState(false);
		} else {
			setRefetchRemainingTime(false);
			sessionStorage.setItem("refetchAllOpenOrdersTime", Date.now());
			const refetch = await refetchOpenOrders(auth.token);
			if (refetch && refetch.status === 200) {

				window.location.reload(true);
			}
			setLoadingState(false);
		}
	};

	useEffect(() => {
		if (!refetchRemainingTime) {
			return;
		}
		const interval = setInterval(() => {
			let fetchedTime = Number(sessionStorage.getItem("refetchAllOpenOrdersTime"));
			const remainingTime = 60 - (Date.now() - fetchedTime) / 1000;
			if (remainingTime >= 0) {
				setRefetchRemainingTime(remainingTime.toFixed(0));
			} else {
				setRefetchRemainingTime(false);
			}
		}, 1000);

		return () => clearInterval(interval);
	}, [refetchRemainingTime]);

	const selectionText = () => {
		if (checkedOrders.length === 0) {
			return "(0)";
		} else {
			return "(" + checkedOrders.length + ")";
		}
	};

const handleCheckedAll = (e) => {
  const allCheckboxes = Array.from(
    document.querySelectorAll(".o-li-item input:not([disabled])")
  );

  if (e.target.checked) {
    allCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked) checkbox.click();
    });
    // Neem de items van de huidige pagina (ordersToShow) op in checked state
    setCheckedOrders(ordersToShow);
  } else {
    allCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) checkbox.click();
    });
    setCheckedOrders([]);
  }
};

	const handleChecked = (checked, order, orderItem) => {
		let newArr = [...checkedOrders];
		if (checked) {
			let orderFound = newArr.find((o) => o.id === order.id);
			if (!orderFound) {
				let orderItemFound = order.orderItems.find(
					(oI) => oI.orderItemId === orderItem.orderItemId
				);
				if (orderItemFound) {
					orderItem.checked = true;
				}
				setCheckedOrders((prevArr) => [...prevArr, order]);
			} else {
				let orderItemFound = orderFound.orderItems.find(
					(oI) => oI.orderItemId === orderItem.orderItemId
				);
				if (orderItemFound) {
					orderItemFound.checked = true;
				}
				setCheckedOrders(newArr);
			}
		} else {
			let newArr = [...checkedOrders];

			let i = newArr.findIndex((o) => o.id === order.id);

			if (i !== -1) {
				let j = newArr[i].orderItems.findIndex(
					(oItem) => oItem.orderItemId === orderItem.orderItemId
				);

				if (newArr[i].orderItems.length <= 1) {
					newArr.splice(i, 1);
				} else {
					if (j !== -1) {
						newArr[i].orderItems[j].checked = false;
					}

					let allUnchecked = Object.values(newArr[i].orderItems).every((item) => {
						return item.checked === false;
					});

					allUnchecked && newArr.splice(i, 1);
				}
				setCheckedOrders(newArr);
			}
		}
	};

const handleCanceledOrderItem = async (order, orderItem) => {
  // 1) Werk openOrders in-memory bij
  let newOpenOrders = [...openOrders];

  newOpenOrders.forEach((o, index) => {
    if (o.orderId === order.orderId) {
      o.orderItems = o.orderItems.filter(
        (oi) => oi.orderItemId !== orderItem.orderItemId
      );
      if (!o.orderItems.length) {
        newOpenOrders.splice(index, 1);
      }
    }
  });

  // 2) Bepaal welke lijst zichtbaar moet zijn (rekening houdend met huidig land-filter)
  const listForView =
    filterCountry === "ALL"
      ? newOpenOrders
      : newOpenOrders.filter(
          (o) => o?.shipmentDetails?.countryCode === filterCountry
        );

  // 3) State + paginatie consistent bijwerken
  setOpenOrders(newOpenOrders);
  setFilteredOrders(listForView);
  showPage(listForView, 0); // terug naar pagina 1 zodat je geen 'lege pagina' krijgt

  // 4) UI-boekhouding
  setRecountOrders((v) => !v);

  // 5) (optioneel) selectie resetten zodat er geen ‘spookselecties’ overblijven
  Array.from(document.querySelectorAll(".o-li-item input:checked")).forEach((cb) => cb.click());
  setCheckedOrders([]);
};

	const cancellationRequestHandler = (order, orderItem) => {
		setCancelOrderItemModal({
			auth: auth,
			order: order,
			orderItem: orderItem,
		});
	};

	let cancelResponseHandler = async (response, order, orderItem) => {
		setCancelResponse(response);
		if (response === 202) {
			handleCanceledOrderItem(order, orderItem);
			setShowAlertText("Artikel geannuleerd");
			setTimeout(() => setShowAlertText(false), 3000);
			setCancelResponse(false);
			setLoadingPage(false);
		} else {
			setShowAlertText("Artikel annuleren mislukt");
			setTimeout(() => setShowAlertText(false), 3000);
			setCancelResponse(false);
			setLoadingPage(false);
		}
	};
	const closeCancelOrderItemModalHandler = (props) => {
		setCancelOrderItemModal(false);
		setLoadingPage(false);
	};

const searchHandler = (e, array) => {
  const q = e.target.value.toLowerCase();
  setSearchQuery(e.target.value);

  const source = openOrders || [];
  const matched = source.filter((order) =>
    JSON.stringify(order).toLowerCase().includes(q)
  );

  setFilteredOrders(matched);
  showPage(matched, 0); // altijd naar pagina 1

  // selectie resetten
 Array.from(
  document.querySelectorAll(".o-li-item input, .checkbox-all-orders input")
 ).forEach((cb) => {    if (cb.checked) cb.click();
  });
  setCheckedOrders([]);
};

	const shipOrdersHandler = (option, order) => {
		let orders = order ? [order] : checkedOrders;
		sessionStorage.setItem("checkedOrders", JSON.stringify(orders));
		sessionStorage.setItem("shippingMethod", JSON.stringify(option));
		navigate("/orders/bol/fbr/dbr/ship/step-1");
	};

	return (
		<React.Fragment>
			<div className='title-header title-header-open-orders'>
				<span>Bestellingen</span>
				<div>
					<div className='header-refetch-container'>
						<Button
							className={refetchRemainingTime && "disableRefetchButton"}
							onClick={() => refetchOpenOrdersHandler()}
						>
							{refetchRemainingTime ? (
								<div className='header-refetch-timer'>{refetchRemainingTime}s</div>
							) : (
								<FaSyncAlt />
							)}
						</Button>
					</div>
				</div>
			</div>
			<OrdersHeader recountOrders={recountOrders} />

			<div className='orders-sub-header'>
				<div className='orders-sub-header-filter-count'>
({filteredOrders ? filteredOrders.length : 0}) <span>bestellingen gefilterd</span>				</div>
				<div className='orders-search-wrapper'>
					<label className='input-search-icon'>
						<GoSearch />
					</label>
					<input
						type='search'
						name='search-form'
						id='search-form'
						className='search-input'
						placeholder='Zoek bestelling...'
						value={searchQuery}
						onChange={(e) => searchHandler(e, openOrders)}
					/>
				</div>
				<div className='orders-sub-header-filter-options'>
					<DropdownButton
						className='filter-open-orders-dropdown'
						align='end'
						id='dropdown-filter-button'
						title={<BsShopWindow />}
						defaultValue={perPage}
						value={perPage}
						onSelect={(e) => {
							filterOrdersByAccount(e);
						}}
					>
						<Dropdown.Item key={-1} eventKey={`{"$exists":true}`}>
							ALLE ACCOUNTS
						</Dropdown.Item>
						{props.bolAccounts &&
							props.bolAccounts.map((bolAccount, i) => {
								return (
									<Dropdown.Item key={i} eventKey={bolAccount.accountSaleNumber}>
										{bolAccount.accountName}
									</Dropdown.Item>
								);
							})}
					</DropdownButton>
					<DropdownButton
						className='filter-open-orders-dropdown'
						align='end'
						id='dropdown-sorting-button'
						title={<AiOutlineSortAscending />}
						defaultValue={perPage}
						value={perPage}
						onSelect={(e) => {
							sortOrders(e);
						}}
					>
						<Dropdown.Item key={89} eventKey={'{"orderItems.offer.reference":1}'}>
							Productgroep (SKU)
						</Dropdown.Item>
						<Dropdown.Item key={90} eventKey={'{"orderPlacedDateTime":-1}'}>
							Besteldatum (Nieuw - Oud)
						</Dropdown.Item>
						<Dropdown.Item key={91} eventKey={'{"orderPlacedDateTime":1}'}>
							Besteldatum (Oud - Nieuw)
						</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>

			{accountFilter && accountFilter !== `{"$exists":true}` && (
				<div className='orders-sub-header-filters'>
					<div className='orders-sub-header-filters-title'>Filters:</div>
					{props &&
						props.bolAccounts &&
						props.bolAccounts.map((bolAccount) => {
							if (bolAccount.accountSaleNumber === accountFilter) {
								return (
									<div className='orders-sub-header-filters-item'>
										<div>{bolAccount.accountName}</div>
										<div className='orders-sub-header-filters-item-close'>
											<FaTimes
												onClick={() => {
													sessionStorage.removeItem("openOrdersFilterByAccount");
													setAccountFilter(`{"$exists":true}`);
												}}
											/>
										</div>
									</div>
								);
							}
						})}
				</div>
			)}
			{sortOrdersFilter && sortOrdersFilter !== `{"orderPlacedDateTime":-1}` && (
				<div className='orders-sub-header-filters'>
					<div className='orders-sub-header-filters-title'>Sortering:</div>
					<div className='orders-sub-header-filters-item'>
						<div>{sortingNameHandler(sortOrdersFilter)}</div>
						<div className='orders-sub-header-filters-item-close'>
							<FaTimes
								onClick={() => {
									sessionStorage.removeItem("openOrdersSorting");
									setSortOrdersFilter(`{"orderPlacedDateTime":-1}`);
								}}
							/>
						</div>
					</div>
				</div>
			)}

			{ordersToShow && (
				<div className='orders-container-header open-orders-container-header'>
					<div className='checkbox-all-orders'>
						<Form.Check
							type='checkbox'
							label={selectionText()}
							onClick={handleCheckedAll}
							disabled={!openOrders}
						/>
					</div>
					{ordersToShow && checkedOrders.length > 0 && (
						<div className='orders-container-header-actions'>
							<Button
								onClick={() => {
									shipOrdersHandler("TNT_BRIEF");
								}}
							>
								PostNL Briefpost
							</Button>
							<Button
								onClick={() => {
									shipOrdersHandler("POSTNL_3085");
								}}
							>
								PostNL Pakket Standaard
							</Button>
							<Button
								onClick={() => {
									shipOrdersHandler("POSTNL_2928");
								}}
							>
								PostNL Brievenbuspakje
							</Button>
							<Button
								onClick={() => {
									shipOrdersHandler("POSTNL_2928_STEALTH");
								}}
								>
								PostNL Brievenbuspakje (Zonder T&T Bol)
						</Button>

						</div>
					)}
				</div>
			)}
			{errorMessage && (
				<div className='noOrdersContainer'>
					<div className='noOrdersText'>
						<div className='no-result-search'>
							<GoSearch />
							{errorMessage}
						</div>
					</div>
				</div>
			)}
			{cancelOrderItemModal && !cancelResponse && (
				<CancelOrderItemModal
					cancelData={cancelOrderItemModal}
					cancelResponseHandler={cancelResponseHandler}
					closeCancelOrderItemModal={closeCancelOrderItemModalHandler}
					loadingStateCancel={() => {
						setLoadingPage("Artikel wordt geannuleerd.");
						setCancelOrderItemModal(false);
					}}
				/>
			)}
			{showAlertText && <div className='snackbar'>{showAlertText}</div>}
			{loadingPage && (
				<div className='loadingStateContainer'>
					<div>
						<div className='sweet-loading processing-page'>
							<RotateLoader
								size={100}
								width={100}
								height={10}
								color={"#162954"}
								loading={loadingPage}
							/>
							<span className='loadingText'>{loadingPage}</span>
						</div>
					</div>
				</div>
			)}
			<div className='orders-container open-orders-container'>
				{ordersToShow &&
					ordersToShow.length > 0 &&
					ordersToShow.map((order, i) => {
						return (
							<div
								key={order.orderId}
								className={
									"o-li-item-container" +
									(order.orderItems && order.orderItems.length > 1
										? " multiOrderItems"
										: "")
								}
							>
								<OrderListItemOpen
									key={order.id}
									order={order}
									distributionParty='DBR'
									handleChecked={handleChecked}
									cancelOrderItem={handleCanceledOrderItem}
									cancellationRequestHandler={cancellationRequestHandler}
								/>
							</div>
						);
					})}
				{ordersToShow && ordersToShow.length === 0 && (
					<div className='noOrdersContainer'>
						<div className='noOrdersText'>
							{searchQuery === "" ? (
								"Alle orders zijn ingepakt, goed zo!"
							) : (
								<div className='no-result-search'>
									<GoSearch />
									Geen resultaat
								</div>
							)}
						</div>
					</div>
				)}
				{loadingState && (
					<div className='loading-container'>
						<div className='loading-container-title'>{loadingState}</div>
						<RotateLoader
							size={100}
							width={100}
							height={10}
							color={"#fff"}
							loading={loadingState}
						/>
					</div>
				)}
			</div>
			{ordersToShow && (
				<ReactPaginate
					previousLabel={"<"}
					nextLabel={">"}
					breakLabel={"..."}
					breakClassName={"break-me"}
					pageCount={pageCount}
					marginPagesDisplayed={5}
					pageRangeDisplayed={5}
					onPageChange={handlePageClick}
					containerClassName={"pagination"}
					activeClassName={"active"}
				/>
			)}
			<AssistantToggleButton />
		</React.Fragment>
	);
};

export default OrdersFbrDbr;